import { UsageCard } from "@/components/insights/InsightsCardItem";
import { useActiveUsersCount } from "@/queries/insights-queries";
import type { TimeRange, View } from "@/routes/insights/insights";
import type { Timestamp } from "@bufbuild/protobuf";
import type { FC } from "react";

type Props = {
    startTimestamp: Timestamp;
    endTimestamp: Timestamp;
    selectedRange: TimeRange;
    selectedView: View;

    handleChangeView: (view: string) => void;
};
export const InsightCards: FC<Props> = ({
    startTimestamp,
    endTimestamp,
    selectedRange,
    selectedView,
    handleChangeView,
}) => {
    const { data: activeUsersCount, isLoading: isLoadingUsers } = useActiveUsersCount(
        startTimestamp,
        endTimestamp,
        selectedRange,
    );

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(350px,1fr))] sm:gap-6">
            <UsageCard
                title="Active users"
                value={
                    isLoadingUsers
                        ? "Loading..."
                        : `${activeUsersCount?.count ? Number(activeUsersCount.count).toLocaleString() : "n/a"}`
                }
                trend={activeUsersCount?.trend ?? 0}
                isLoading={isLoadingUsers}
                selected={selectedView === "activeUsers"}
                handleClick={() => handleChangeView("activeUsers")}
            />
            <UsageCard
                title="Environments"
                value={`${"n/a"}`}
                trend={0}
                isLoading={false}
                selected={selectedView === "environments"}
                handleClick={() => handleChangeView("environments")}
            />
            <UsageCard
                title="Total time"
                value={`${"n/a"}`}
                trend={0}
                isLoading={false}
                selected={selectedView === "totalTime"}
                handleClick={() => handleChangeView("totalTime")}
            />
        </div>
    );
};
